var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTag3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h16a4 4 0 014 4v30l-12 8-12-8V4z",
    fill: "#22232C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.937 21.512L11.681 24h2.239l-1.802 1.296.738 2.408-1.92-1.472-1.921 1.472.738-2.408L7.952 24h2.239l.745-2.488zm-1.921.888H3l4.897 3.528L6.04 32l4.897-3.752L15.84 32l-1.865-6.072 4.897-3.528h-6.016l-1.92-6.4-1.921 6.4zM19.159 32l-1.476-4.808L21 24.8h-2.73l-2.445 1.76 1.16 3.776L19.158 32zm-3.46-11.2L14.253 16l-.825 2.76.61 2.04h1.66z",
    fill: "url(#tag3Icon_svg__paint0_linear_605_1796)",
    style: {
      mixBlendMode: "lighten"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tag3Icon_svg__paint1_linear_605_1796)",
    strokeWidth: 2,
    d: "M24 5H0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tag3Icon_svg__paint0_linear_605_1796",
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9CAC",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tag3Icon_svg__paint1_linear_605_1796",
    x1: 24,
    y1: 4,
    x2: 0,
    y2: 3.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CAC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#9A9CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9CAC",
    stopOpacity: 0
  })))));
}

export default SvgTag3Icon;